module.exports = __webpack_public_path__ + "static/stormwater.a7fbfbca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stormwater.jpg
// module id = 437
// module chunks = 35783957827783